let authAxios

const __authAxios = _authAxios => {
  authAxios = _authAxios
}

export const login = async (username, password, checkAuth = false) => {
  const response = await authAxios.post("/login", { username, password }, checkAuth)

  if (checkAuth) {
    return response.success
  }

  if (response.success) {
    return response.user
  }
}

export const fetchAppLookups = async () => {
  try {
    const response = await authAxios.get("/lookups")
    return response.data
  } catch (error) {
    console.error("Failed to fetch lookups:", error)
    return null
  }
}

export const checkAuth = async () => {
  try {
    const response = await authAxios.get("/checkAuth")
    return response.success === true
  } catch (error) {
    return false
  }
}

export const logout = async () => {
  await authAxios.get("/logout")
  localStorage.clear()
  sessionStorage.clear()
}

export default __authAxios
